<template>
  <div class="filter-shops" id="filter-shops" v-if="isEnable()">
    <div class="filter-shops__search">
      <label class="form-label">Название магазина</label>
      <div class="row g-2">
        <div class="col">
          <div class="input-icon">
            <input @keyup.enter="events.onSearch" type="text" v-model="data.search" class="form-control" placeholder="Название магазина">
            <button class="btn input-icon-addon__button" @click="events.onSearch">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="10" cy="10" r="7" />
                <line x1="21" y1="21" x2="15" y2="15" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-post__buttons">
      <label class="form-label">&nbsp;</label>
      <div class="form-selectgroup">
        <label class="form-selectgroup-item">
          <input @change="events.onStatuses" type="checkbox" v-model="data.isNew" class="form-selectgroup-input">
            <span class="form-selectgroup-label">
              <IconNewSection class="me-1"/>
                Новые
            </span>
        </label>
        <label class="form-selectgroup-item">
          <input @change="events.onStatuses" type="checkbox" v-model="data.isActive" class="form-selectgroup-input">
            <span class="form-selectgroup-label">
              <IconSun class="me-1"/>
                Активно
            </span>
        </label>
        <label class="form-selectgroup-item">
          <input @change="events.onStatuses" type="checkbox" v-model="data.isDelst" class="form-selectgroup-input">
            <span class="form-selectgroup-label">
              <IconTrash class="me-1"/>
                На удаление
            </span>
        </label>
        <label class="form-selectgroup-item">
          <input @change="events.onStatuses" type="checkbox" v-model="data.isLinked" class="form-selectgroup-input">
            <span class="form-selectgroup-label">
              <IconLink class="me-1"/>
                Связан
            </span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import './css/style.css'
import {defineComponent, onMounted, reactive} from "vue"
import IconSun from '@/assets/icons/IconSun'
import IconLink from '@/assets/icons/IconLink'
import IconTrash from '@/assets/icons/IconTrash'
import IconNewSection from '@/assets/icons/IconNewSection'

export default defineComponent({
  name: "Filter",
  components: {
    IconSun,
    IconLink,
    IconTrash,
    IconNewSection,
  },
  props: {
    params: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const variantsData = reactive({
      categories: [],
    })

    let data = reactive({
      search: props.params.search ?? '',
      enable: props.params.search !== '',
      isNew: props.params.is_not_parsed ?? false,
      isActive: props.params.is_published ?? false,
      isDelst: props.params.is_delst ?? false,
      isLinked: props.params.is_linked ?? false,
    })

    const events = {
      onSearch: () => {
        onFilter()
      },
      onStatuses: () => {
        onFilter()
      }
    }

    function onFilter() {
      setTimeout(() => {
        emit("onFilter", getResult())
      }, 300)
    }

    function getResult() {
      let ret = {}

      if (data.search !== '') {
        ret["search"] = data.search
      }
      if (data.isNew !== false) {
        ret["is_not_parsed"] = true
      }
      if (data.isActive !== false) {
        ret["is_published"] = true
      }
      if (data.isDelst !== false) {
        ret["is_delst"] = true
      }
      if (data.isLinked !== false) {
        ret["is_linked"] = true
      }

      return ret
    }

    function isEnable() {
      return props.params.enable === true
    }

    onMounted(() => {
      onFilter()
    })

    return {
      events,
      data,
      variantsData,
      isEnable,
    }
  }
})
</script>
